import * as React from "react"
import {PlaceIcon} from "./PlaceIcon"
import {PlaceNicknameLabel} from "./PlaceNicknameLabel"
import {maybeCommonPlace, maybePlaceNickname, placeAddress} from "../model/places/place"
import {CommonPlace, Place, PlaceNickname} from "../model/places/PlaceTypes"
import {isReady, Loading, loadingIfNull} from "../tsutil"
import {CommonPlaces, PlaceNicknames} from "../graphql/queries"
import {GraphQL} from "../graphql"

interface OwnProps {
  place: Loading<Place>
}

type Props = OwnProps & NicknamesProp & CommonPlacesProp

function PlaceSuggestionComponent({commonPlaces, placeNicknames, place}: Props) {
  if (
    !isReady(commonPlaces) ||
    !isReady(placeNicknames) ||
    // Rendering with an empty place primes the graphql queries
    !isReady(place)
  ) {
    return null
  }
  const {id, category, type} = place.value

  const nickname = maybePlaceNickname(placeNicknames.value, id)

  if (nickname) {
    return <PlaceNicknameLabel nickname={nickname.label} pointing={false} />
  }

  // TODO This small change fixes the missing icon on common places but frankly the whole
  // place/common place/nickname/backend/frontend shenanigans is too complicated just now...
  const commonPlace = maybeCommonPlace(commonPlaces.value, id)
  const effectiveCategory = commonPlace ? commonPlace.category : category
  const effectiveName = commonPlace ? commonPlace.label : placeAddress(place.value)

  return (
    <span>
      <PlaceIcon type={type} category={effectiveCategory} />
      {effectiveName}
      <span style={{display: "inline-block", width: "4px"}} />
    </span>
  )
}

interface NicknamesProp {
  placeNicknames: Loading<Array<PlaceNickname>>
}

function WithPlaceNicknames(props: OwnProps & CommonPlacesProp) {
  return (
    <GraphQL.Query
      query={PlaceNicknames}
      variables={{}}
      render={({data}) => {
        return (
          <PlaceSuggestionComponent
            {...props}
            placeNicknames={loadingIfNull(data).map((data) => data.placeNicknames)}
          />
        )
      }}
    />
  )
}

interface CommonPlacesProp {
  commonPlaces: Loading<Array<CommonPlace>>
}

function WithCommonPlaces(props: OwnProps) {
  return (
    <GraphQL.Query
      query={CommonPlaces}
      variables={{}}
      render={({data}) => {
        return (
          <WithPlaceNicknames
            {...props}
            commonPlaces={loadingIfNull(data).map((data) => data.commonPlaces)}
          />
        )
      }}
    />
  )
}

export {WithCommonPlaces as PlaceSuggestion}



// WEBPACK FOOTER //
// ./src/components/PlaceSuggestion.tsx